import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";

import BotEmbedScreen from "./BotEmbedScreen";
import { BotEmbedProvider } from "./BotEmbedContext";
import { DEFAULT_BOT_ID } from "./constants";
import { extractBotId } from "./mockData";

const resolveLocationBotId = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return extractBotId(new URLSearchParams(window.location.search).get("id"));
};

const BotEmbed = ({
  botId = "",
  mode = "embed",
  muiPortalContainer = null,
  shadowRoot = null,
}) => {
  const fallbackBotId =
    extractBotId(botId) || resolveLocationBotId() || DEFAULT_BOT_ID;
  const [selectedBotId, setSelectedBotId] = useState(fallbackBotId);
  const [shortCodeInput, setShortCodeInput] = useState(fallbackBotId);
  const muiCacheRef = useRef(null);

  if (
    shadowRoot &&
    (!muiCacheRef.current || muiCacheRef.current.sheet.container !== shadowRoot)
  ) {
    muiCacheRef.current = createCache({
      container: shadowRoot,
      key: "bb-embed",
      prepend: true,
    });
  }

  useEffect(() => {
    setSelectedBotId(fallbackBotId);
    setShortCodeInput(fallbackBotId);
  }, [fallbackBotId]);

  const content = (
    <BotEmbedProvider botId={selectedBotId} mode={mode}>
      <BotEmbedScreen
        mode={mode}
        muiPortalContainer={muiPortalContainer}
        setSelectedBotId={setSelectedBotId}
        setShortCodeInput={setShortCodeInput}
        shortCodeInput={shortCodeInput}
      />
    </BotEmbedProvider>
  );

  if (muiCacheRef.current) {
    return <CacheProvider value={muiCacheRef.current}>{content}</CacheProvider>;
  }

  return content;
};

export default BotEmbed;
